module.exports = __webpack_public_path__ + "static/media/background.3199a4c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/washington-dc/background.jpg
// module id = 911
// module chunks = 27